import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, defaultLocale, namespaces } from '@koyomi/i18n';

/** Strings só em /packages/i18n. Idioma inicial: preferência salva → navegador → pt-BR. */
function initialLocale(): string {
  try {
    const saved = localStorage.getItem('koyomi.locale');
    if (saved && saved in resources) return saved;
  } catch { /* sem storage */ }
  const nav = navigator.language;
  return nav in resources ? nav : nav.startsWith('en') ? 'en-US' : defaultLocale;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLocale(),
  fallbackLng: defaultLocale,
  ns: namespaces,
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export function setLocale(locale: string) {
  try { localStorage.setItem('koyomi.locale', locale); } catch { /* ignore */ }
  void i18n.changeLanguage(locale);
}

export default i18n;
